module.exports = function() {
	var headerInit = document.querySelector('.js-headerblock'),
		headerHeight = headerInit.offsetHeight,
		menuInit = document.querySelector('.js-menu'),
		menuHeight = menuInit.offsetHeight;

	function addClass(o, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", "g");
	
		if (re.test(o.className)) return;
	
		o.className = (o.className + " " + c).replace(/\s+/g, " ").replace(/(^ | $)/g, "");
	}

	function removeClass(o, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", "g");
	
		o.className = o.className.replace(re, "$1").replace(/\s+/g, " ").replace(/(^ | $)/g, "");
	}

	function hasClass(o, c) {
		return (' ' + o.className + ' ').indexOf(' ' + c + ' ') > -1;
	}

	window.onscroll = function() {
		var windowPos = window.pageYOffset || document.documentElement.scrollTop;

		if (windowPos > headerHeight) {

			if (!hasClass(menuInit, "st-scrolled")) {
				addClass(menuInit, "st-scrolled");
			}

		} else {

			if (hasClass(menuInit, "st-scrolled")) {
				removeClass(menuInit, "st-scrolled");	
			}
			
		}
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/menu.js
 **/